<template>
  <v-parallax dark :src="src">
    <v-row align="center" justify="center">
        <!-- Info -->
      <v-col 
        v-for="item in datos"
        :key="item.title"
        class="text-center" 
        lg="4"
        md="4"
        sm="12"
        cols="12">
        <v-icon x-large class="pb-3" color="white">{{item.icono}}</v-icon>
        <h1 class="display-1 mb-4" v-text="$t(`localidades[`+item.id+`].titulo`)"></h1>
        <h4 class="subtitle-1" v-text="$t(`localidades[`+item.id+`].descripcion`)"></h4>
      </v-col>
        <!-- Fin Info -->
    </v-row>
  </v-parallax>
</template>

<script>
export default {
  data() {
    return {
      src: require("../assets/universe.jpg"),
      datos:[
          {icono: 'mdi-map-marker', id: 0, description: 'We share the sky with the international scientific observatories: Tololo, Gemini and SOAR, with about 300 clear nights a year.'},
          {icono: 'mdi-medal', id: 1, description: 'The International Dark-Sky Association declared Elqui valley the world’s first International Dark Sky Sanctuary in 2015 due to the unrivalled purity of its skies.'},
          {icono: 'mdi-star', id: 2, description: 'The Elqui Valley is one of the few places where you can see up to the eighth magnitude with the naked eye and whose geographical position is such that you can see the center of the galaxy with ease.'}
      ]
    };
  },
  props:[
    'localidad'
  ]
};
</script>